/** 无基地查询权限时传给后端的基地 Id */
export const FISH_BASE_NO_PERMISSION = -1;

/**
 * 权限内无基地可选时，列表查询接口需附加的基地参数。
 * @param {Array} baseList
 * @returns {{ fishBaseId: number } | {}}
 */
export function fishBaseNoPermissionQueryParams(baseList) {
  if (!Array.isArray(baseList) || baseList.length === 0) {
    return { fishBaseId: FISH_BASE_NO_PERMISSION };
  }
  return {};
}

/**
 * 按基地下拉列表校正待提交的基地主键（与 getAllBaseList({ forQueryAll: true }) 结果配套使用）。
 * 当缓存中的 key 已不在当前列表（例如无「全部」权限）时，回退为列表第一项，避免接口收到空/无效 key 而返回全部基地数据。
 * 列表为空时表示用户无基地查询权限，返回 null，下拉保持空态（不使用 localStorage 中的旧值）。
 * @param {Array<{ key: any, value?: string }>} baseList
 * @param {any} storedKey storage / localStorage 等处读出的已选 key；无记录时传 undefined
 */
export function resolveFishBaseKeyFromList(baseList, storedKey) {
  if (!Array.isArray(baseList) || baseList.length === 0) {
    return null;
  }
  const first = baseList[0];
  if (storedKey === undefined || storedKey === null) {
    return first.key;
  }
  const match = baseList.find(
    (x) =>
      x &&
      (x.key === storedKey ||
        (x.key != null &&
          storedKey != null &&
          String(x.key) === String(storedKey)))
  );
  return match ? match.key : first.key;
}

/**
 * 基地下拉绑定为 item.value（如喂养、防疫、渔肥）时使用。
 * 列表为空时返回 null，避免展示 localStorage 中的无效旧值。
 * @param {Array<{ key: any, value?: string }>} baseList
 * @param {any} storedValue 缓存中的已选展示值；无记录时传 undefined
 */
export function resolveFishBaseValueFromList(baseList, storedValue) {
  if (!Array.isArray(baseList) || baseList.length === 0) {
    return null;
  }
  const first = baseList[0];
  if (storedValue === undefined || storedValue === null) {
    return first.value;
  }
  const match = baseList.find((x) => x && x.value === storedValue);
  return match ? match.value : first.value;
}

/**
 * 列表查询接口使用的基地 Id：无权限基地时固定传 -1。
 * @param {any} fishBaseId 页面 v-model 绑定的基地 key
 * @param {Array<{ key: any }>} baseList 当前权限内基地列表
 */
export function fishBaseIdForQuery(fishBaseId, baseList) {
  if (!Array.isArray(baseList) || baseList.length === 0) {
    return FISH_BASE_NO_PERMISSION;
  }
  if (fishBaseId === undefined || fishBaseId === null) {
    return baseList[0].key;
  }
  if (fishBaseId === "") {
    return "";
  }
  const match = baseList.find(
    (x) =>
      x &&
      (x.key === fishBaseId ||
        (x.key != null &&
          fishBaseId != null &&
          String(x.key) === String(fishBaseId)))
  );
  return match ? match.key : baseList[0].key;
}
